import Vue from 'vue';
import Vuex from 'vuex';

import Prismic from 'prismic-javascript';
import PrismicConfig from '../prismic.config';

const prismicEndpoint = PrismicConfig.endpoint;

Vue.use(Vuex);

export default function createStore() {
  return new Vuex.Store({
    state: () => ({
      app: {},
      homePage: {},
      pages: [],
      reports: []
    }),
    mutations: {
      setApp(state, app) {
        state.app = app;
      },
      setHomePage(state, homePage) {
        state.homePage = homePage;
      },
      setPages(state, pages) {
        state.pages = pages;
      },
      setReports(state, reports) {
        state.reports = reports;
      }
    },
    actions: {
      async getApp({ commit, state }) {
        if (Object.keys(state.app).length) {
          return Promise.resolve();
        }

        const api = await Prismic.getApi(prismicEndpoint);
        const app = await api.getSingle('app');

        commit('setApp', app.data);
      },
      async getHomePage({ commit, state }) {
        if (state.homePage.length) {
          return Promise.resolve();
        }

        await Prismic.getApi(prismicEndpoint)
          .then(api =>
            api.query(Prismic.Predicates.at('document.type', 'home'), {
              lang: Vue.config.lang,
              pageSize: 1
            })
          )
          .then(({ results }) => {
            commit('setHomePage', results[0]);
          });
      },
      async getPages({ commit, state }) {
        if (state.pages.length) {
          return Promise.resolve();
        }

        const api = await Prismic.getApi(prismicEndpoint);
        const res = await api.query(
          Prismic.Predicates.at('document.type', 'page'),
          {
            lang: Vue.config.lang,
            pageSize: 100
          }
        );
        commit('setPages', res.results);
      },
      async getReports({ commit, state }) {
        if (state.reports.length) {
          return Promise.resolve();
        }

        const api = await Prismic.getApi(prismicEndpoint);
        const res = await api.query(
          Prismic.Predicates.at('document.type', 'report'),
          {
            lang: Vue.config.lang,
            pageSize: 100
          }
        );
        commit('setReports', res.results);
      }
    }
  });
}
